exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.add-tender-btn[data-v-5695261f] {\n  margin: 28px 0 0 20px;\n  padding-bottom: 48px;\n}\n.add-tender-btn[data-v-5695261f]  .v-btn {\n  padding: 0;\n}\n.add-tender-btn[data-v-5695261f]  span {\n  margin-left: 24px;\n}\n", ""]);

